module.exports = __webpack_public_path__ + "static/media/amass360-logo.bb52eab7.png";